import { BoxProps, CSSObject } from '@chakra-ui/react';

export const wrapper: BoxProps = {};
export const FormWrapper: CSSObject = {
  color: 'white',
  p: '2',
  '.chakra-checkbox__control': {
    borderColor: 'gray.400',
  },
  '.chakra-form__label': {
    color: 'white',
  },
  '&&': {
    '.chakra-checkbox__control[data-checked]': {
      bg: 'white',
      borderColor: 'gray.700',
    },
  },
};
